import LeadsAccountsTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: { LeadsAccountsTable },
  data() {  
    return {
      leads: [],
      customers: [],
      meta: {
      currentPage: 1,
      totalPages: 1,
      totalElements: 0,
      pageSize: 100
     },
      loading: false,
      autoLoad: false,
      autoLoadInterval: null,
      lastOpts: {}, // Aquí se guardan los filtros usados 
      page: { number: 1, size: 100 },
      perPageLoad: 20
    }
  },
  created() {
    this.loadCustomers()
    this.$setPageTitle(this.$t('leads.index.title'))
    this.$setBreadcrumbs([{ label: this.$t('leads.index.subtitle'), route: {} }])
    this.loadLeadsDetails()
  },
  watch: {
   autoLoad(val) {
  // Limpiar intervalo si está activo
  if (this.autoLoadInterval) {
    clearInterval(this.autoLoadInterval);
    this.autoLoadInterval = null;
  }

  if (val) {
    this.autoLoadInterval = setInterval(() => {
      this.loadLeadsDetails({
        ...this.lastOpts,
        page: {
          number: this.page.number,
          size: this.page.size
        }
      }, { append: false }) // false si quieres refrescar, true si quieres agregar
    }, 120000);
  }
}

  },
  methods: {
    loadCustomers() {
      API.customers
        .index({ order: { name: 'asc' } })
        .then(({ data }) => {
          this.customers = [{ id: '0', name: this.$t('general.all') }, ...data]
        })
    },

  loadLeadsDetails(opts = {}, { append = false } = {}) {
  if (this.loading) return; // evita llamadas múltiples si ya está cargando

  this.loading = true;
  this.lastOpts = { ...opts }; // guarda los opts usados más recientes
  // Obtener la página y tamaño actual
  const page = opts.page || {
    number: this.page.number,
    size: this.page.size
  };

  // Llamada al API
  API.accounts
    .leadsByAccount(this.$user.accountId, { ...opts, page })
    .then(({ data, meta }) => {
      const mapped = data.map(l => ({
        id: l.id,
        leadId: l.id,
        createdAt: l.date,
        phone: l.phone,
        leadCTIId: l.idLeadCti,
        firstName: l.firstName,
        secondName: l.lastName,
        email: l.email,
        campaign: l.campaignName,
        state: l.leadStatus,
        callCenter: l.callCenterName,
        customer: l.customerName,
        customerId: l.customerId,
        provider: l.providerName,
        providerId: l.providerId,
        category: l.category,
        cta: l.cta,
        ctaType: l.cta,
        service: l.serviceIdDestination,
        statusCTI: l.statusCti,
        utmSource: l.utmSource,
        utmCampaign: l.utmCampaign,
        utmMedium: l.utmMedium,
        leadSourceId: l.idLeadSource,
        visitorId: l.visitorId,
        fullName: l.fullName,
        agentId: l.agentId,
        agentName: l.agentName,
        agentType: l.agentType,
        agentSupervisor: l.agentSupervisorName,
        agentProvince: l.agentProvince,
        agentProducts: l.agentProducts,
        formProvider: l.formProvider
      }));

      
      if (append) {
        this.leads = this.leads.concat(mapped);
        this.page.number++; // avanzar página
      } else {
        this.leads = mapped;
        this.page.number = 1; // reiniciar si es carga nueva
      }
      this.meta = meta;
    })
    .finally(() => {
      this.loading = false;
    });
},

  onScroll(e) {
  const el = e.target;

  // Ya en la última página, no hagas más peticiones
  if (this.meta.currentPage >= this.meta.totalPages) return;

  // Verifica si estamos cerca del final del scroll
  const isNearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;

  if (isNearBottom && !this.loading) {
    this.loadLeadsDetails({
      ...this.lastOpts,
      page: {
        number: this.meta.currentPage + 1,
        size: this.meta.pageSize
      }
    }, {
      append: true
    });
  }
}
  
  }
})
